// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vx-region-label{position:absolute;top:4rem;left:4rem;z-index:15}\n", ""]);
// Exports
module.exports = exports;
